<template>
    <b-modal
        v-model="modalShow"
        size="lg"
        title="英語化問診票作成： 相談科を選択"
        @hidden="close">
        <div v-if="medicalCourses.length > 0">
            <div class="mb-3">英語化問診票を作成したい相談科を選択してください。<br>相談科に応じた問診内容が表示されます。</div>
            <div class="medicalCourseBtnWrapper">
                <div
                    v-for="medicalCourse in medicalCourses"
                    @click="onClickMedicalCourseBtn(medicalCourse, $event)"
                    class="medicalCourseBtn">
                    {{ medicalCourse.name }}
                </div>
            </div>
        </div>
        <div slot="modal-footer" class="pt-2 pb-2"></div>
    </b-modal>
</template>

<script>
    import YokumiruHelper from '../../../YokumiruHelper'
    import {mapMutations} from "vuex";

    export default {
        name: 'UserInterviewTransQuestionsModal',

        props: {
            user: {
                type: Object,
                required: true,
            },
            medicalCourses: {
                type: Array,
                default: [],
            },
        },

        data: function () {
            return {
                helper: YokumiruHelper,
                modalShow: false,
            }
        },

        computed: {},

        created: function () {
            bus.$on('open-modal-user-interview-trans-question-medical-courses', this.open)
            bus.$on('user-interview-trans-completed', this.close)
        },

        beforeDestroy: function () {
            bus.$off('open-modal-user-interview-trans-question-medical-courses')
            bus.$off('user-interview-trans-completed')
        },

        methods: {
            ...mapMutations({
                clearStates: 'userInterviewTransAnswers/clearStates',
            }),

            /**
             * モーダル表示
             */
            open: function () {
                this.clearStates()
                this.modalShow = true
            },

            /**
             * モーダル非表示
             */
            close: function () {
                this.clearStates()
                this.modalShow = false
            },

            /**
             * 相談科ボタン押下時
             * @param {object} medicalCourse
             * @param {object} e
             */
            onClickMedicalCourseBtn: function (medicalCourse, e) {
                bus.$emit('open-modal-user-interview-trans-questions', medicalCourse, this.user)
            },
        },
    }
</script>

<style scoped lang="scss">
.medicalCourseBtnWrapper {
    margin-top: 20px;

    .medicalCourseBtn {
        display: inline-block;
        width: 32%;
        margin: 5px;
        padding: 10px;
        color: #3F3F3F;
        font-size: 16px;
        font-weight: bold;
        text-align: center;
        border-radius: 8px;
        background-color: #F8F8F8;
        border: 1px solid #ececec;
        box-sizing: border-box;
        cursor: pointer;
        transition: background-color 0.2s ease-in-out, color 0.2s ease-in-out, border 0.2s ease-in-out;

        @media screen and (max-width: 991px) {
            width: 47%;
        }

        @media screen and (max-width: 575px) {
            width: 100%;
            margin-left: 0;
            margin-right: 0;
        }

        &:hover {
            color: #fff;
            background-color: #F77696;
            border: 1px solid #F77696;
        }
    }
}
</style>
